import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getAccountExpenseTypeList,
  getAccountExpenseTypeById,
  createAccountExpenseType,
  updateAccountExpenseType,
  deleteAccountExpenseType,
} from "api/accountExpenseTypeApi"

export const ACCOUNT_EXPENSE_TYPE_QUERY_KEY = "account-expense-type"

export const useAccountExpenseTypes = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_EXPENSE_TYPE_QUERY_KEY,
    getAccountExpenseTypeList,
    params,
    enabled
  )
}

export const useAccountExpenseType = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_EXPENSE_TYPE_QUERY_KEY,
    getAccountExpenseTypeById,
    id,
    enabled
  )
}

export const useCreateAccountExpenseType = () => {
  return useCreateResource(
    createAccountExpenseType,
    ACCOUNT_EXPENSE_TYPE_QUERY_KEY
  )
}

export const useEditAccountExpenseType = () => {
  return useEditResource(
    updateAccountExpenseType,
    ACCOUNT_EXPENSE_TYPE_QUERY_KEY
  )
}

export const useDeleteAccountExpenseType = () => {
  return useDeleteResource(
    deleteAccountExpenseType,
    ACCOUNT_EXPENSE_TYPE_QUERY_KEY
  )
}
